import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Card, CardText, CardHeader, Table,
  TableHeader, TableRow, TableHeaderColumn, TableBody, TableRowColumn } from "material-ui";
import { BuscarHistorialReajustes } from "../FiltroBusqueda/actions";


const styles = {
  formatColumnHeader: {
    whiteSpace: "normal",
    wordWrap: "break-word",
  },
};

class HistorialReajustes extends React.Component {
  componentWillMount() {
    this.props.dispatch(BuscarHistorialReajustes());
  }

  GetDescripcionArancel = (rut) => {
    const glosaS = this.props.tiposArancel.filter((ts) => ts.Rut === rut);
    if (glosaS && glosaS.length === 1) {
      return glosaS[0].Descripcion;
    }
    return "-";
  }

  GetDescripcionTipoPrestacion = (id) => {
    const glosaS = this.props.tiposPrestaciones.filter((ts) => ts.Id === id);
    if (glosaS && glosaS.length === 1) {
      return glosaS[0].Descripcion;
    }
    return "-";
  }

  GetDescripcionCentroAtencion = (secuencia) => {
    const glosaS = this.props.centrosAtencion.filter((ts) => ts.Secuencia === secuencia);
    if (glosaS && glosaS.length === 1) {
      return glosaS[0].Descripcion;
    }
    return "-";
  }

  render() {
    const menuItemsHistorialReajustes = [];
    if (this.props.historialReajustes && this.props.historialReajustes.length > 0) {
      this.props.historialReajustes.map((row, index) => (
        menuItemsHistorialReajustes.push((
          <TableRow key={index}>
            <TableRowColumn>{row.RutInstitucion}</TableRowColumn>
            <TableRowColumn>{this.GetDescripcionArancel(row.RutArancel)}</TableRowColumn>
            <TableRowColumn>{this.GetDescripcionCentroAtencion(row.CentroAtencionSecuencia)}</TableRowColumn>
            <TableRowColumn>{this.GetDescripcionTipoPrestacion(row.GrupoPrestacionIsapre)}</TableRowColumn>

            <TableRowColumn>{(new Date(row.FechaCreacion)).toLocaleDateString()}</TableRowColumn>
            <TableRowColumn>{row.ValorReajuste}</TableRowColumn>
            <TableRowColumn>{row.Estado || "-----"}</TableRowColumn>
          </TableRow>
        ))
      ));
    }


    return (

      <div style={{ padding: "5px" }}>
        <Card initiallyExpanded={false} >
          <CardHeader
            title="Historial de Reajustes"
            subtitle=""
            actAsExpander
            showExpandableButton
            style={{
              paddingTop: "5px", paddingBottom: "5px",
            }}
          >
          </CardHeader>
          <CardText expandable>

            <Table
              key="tablaHistorialReajustes"
              fixedHeader
              fixedFooter
              selectable={false}
              height={menuItemsHistorialReajustes.length > 8 ? "400px" : null}
            >
              <TableHeader
                adjustForCheckbox={false}
                displaySelectAll={false}
              >
                <TableRow>
                  <TableHeaderColumn style={styles.formatColumnHeader} colSpan={4} >Información del Prestador</TableHeaderColumn>
                  <TableHeaderColumn style={styles.formatColumnHeader} colSpan={3} >Último Reajuste aplicado</TableHeaderColumn>
                </TableRow>
                <TableRow selectable={false} >
                  <TableHeaderColumn style={styles.formatColumnHeader} >Rut Institución</TableHeaderColumn>
                  <TableHeaderColumn style={styles.formatColumnHeader} >Tipo de Arancel</TableHeaderColumn>
                  <TableHeaderColumn style={styles.formatColumnHeader} >Centro de Atención</TableHeaderColumn>
                  <TableHeaderColumn style={styles.formatColumnHeader} >Tipo de Prestación</TableHeaderColumn>

                  <TableHeaderColumn style={styles.formatColumnHeader} >Fecha</TableHeaderColumn>
                  <TableHeaderColumn style={styles.formatColumnHeader} >% Reajuste</TableHeaderColumn>
                  <TableHeaderColumn style={styles.formatColumnHeader} >Estado</TableHeaderColumn>
                </TableRow>
              </TableHeader>
              <TableBody
                displayRowCheckbox={false}
                deselectOnClickaway={false}
                showRowHover
                stripedRows={false}
              >
                {menuItemsHistorialReajustes}
              </TableBody>
            </Table>


          </CardText>
        </Card>
      </div>


    );
  }
}


HistorialReajustes.propTypes = {
  rutInstitucion: PropTypes.number.isRequired,
  tiposArancel: PropTypes.array.isRequired,
  centrosAtencion: PropTypes.array.isRequired,
  tiposPrestaciones: PropTypes.array.isRequired,
  historialReajustes: PropTypes.array.isRequired,
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  rutInstitucion: state.global.rutInstitucion,
  tiposArancel: state.global.tiposArancel,
  centrosAtencion: state.global.filtros_CAT.centrosAtencion,
  tiposPrestaciones: state.global.tiposPrestaciones,
  historialReajustes: state.filtroBusquedaRA.historialReajustes,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});


export default connect(mapStateToProps, mapDispatchToProps)(HistorialReajustes);




// WEBPACK FOOTER //
// ./src/components/ReajustarArancel/HistorialReajustes/view.jsx